import * as Y from 'yjs';

import { AnswerStyleType } from 'shared/types/AnswerStyleType';
import { ChartType } from 'shared/types/ChartType';
import { WidgetType } from 'shared/widgets/utils';

import { DEFAULT_ANSWERS_AMOUNT, defaultAnswerConfig } from './consts';
import { manifestLocales } from './manifest.locales';
import { createNewInteractiveQuizAnswerData } from '@/contentObjects/InteractiveQuizAnswer/create';
import { InitializePropsOptions, ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';
import { createQuestionWidgetChildren } from '@/widgets/utils/createQuestionWidgetChildren';
import { initializeAnswers } from '@/widgets/utils/initializeAnswers';

export function createNewInteractiveQuizData(options?: InitializePropsOptions): ManifestInitializedProps {
  const id = genRandId();
  const locale = options?.locale ?? 'he';
  const { initialHeadlineText } = manifestLocales.interactiveQuiz;
  const labelFragment = htmlToXmlFragment(`<h2><span>${initialHeadlineText[locale]}</span></h2>`);
  const answers = initializeAnswers(defaultAnswerConfig, DEFAULT_ANSWERS_AMOUNT);

  const [questionAnswerData] = createNewInteractiveQuizAnswerData();
  const { childrenArray, horizontalFlexSectionData, verticalFlexSectionData } = createQuestionWidgetChildren(
    questionAnswerData.id,
    options?.width
  );

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.InteractiveQuiz],
        ['children', childrenArray],
        ['labelFragment', labelFragment],
        ['answers', answers],
        ['amountOfColumns', 1],
        ['answerElements', ['Text']],
        ['answersStyle', AnswerStyleType.Default],
        ['answersVisualization', ChartType.HorizontalBarChart],
        ['questionAnswerId', questionAnswerData.id]
      ]),
      sensitiveData: new Y.Map([['correctAnswers', []]])
    },
    verticalFlexSectionData,
    horizontalFlexSectionData,
    questionAnswerData
  ];
}
